import { useTranslation } from "react-i18next";

export default function Service() {
  const { t } = useTranslation();

  return <div>This is {t("service")}</div>;
}
